import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check, Loader2 } from "lucide-react";

export const Cta = ({ to, href, onClick, label, variant = "plum", size = "md", full, icon, state = "idle", disabled, testId, type = "button", className = "" }) => {
  const cls = `rh-cta rh-cta--${variant} rh-cta--${size} ${full ? "w-full" : ""} ${className}`;
  const inner = (
    <>
      <span className="truncate">{label}</span>
      <span className="rh-cta__tile">
        {state === "loading" ? <Loader2 className="w-[18px] h-[18px] animate-spin" />
          : state === "done" ? <Check className="w-[18px] h-[18px]" strokeWidth={2.6} />
          : icon || <ArrowUpRight className="rh-cta__arrow w-[19px] h-[19px]" strokeWidth={2.3} />}
      </span>
    </>
  );
  if (to) return <Link to={to} className={cls} data-testid={testId}>{inner}</Link>;
  if (href) return <a href={href} className={cls} data-testid={testId}>{inner}</a>;
  return (
    <button type={type} onClick={onClick} disabled={disabled || state === "loading"} className={cls} data-testid={testId} data-state={state}>
      {inner}
    </button>
  );
};

export const AddToBagButton = ({ onAdd, disabled, label = "Add to bag", ...rest }) => {
  const [state, setState] = useState("idle");
  const click = async () => {
    setState("loading");
    try {
      await onAdd();
      setState("done");
      setTimeout(() => setState("idle"), 1800);
    } catch {
      setState("idle");
    }
  };
  return <Cta {...rest} onClick={click} state={state} disabled={disabled} label={disabled ? "Sold out" : state === "done" ? "Added" : label} />;
};
